/**
 * Dev-only backends (Ollama :11434, AI manager :8000, location API :8001) default to a
 * http://localhost URL when no REACT_APP_* env var is configured. On the DEPLOYED site those
 * hosts are unreachable and the browser blocks the plain-http request as mixed content, which
 * spams the console with "blocked" + "Load failed" errors on every page load.
 *
 * isLocalApiUnavailable() returns true when a localhost API base can't work because the app
 * itself is served from a non-local host — so callers can skip the request and fall back
 * silently instead of firing a doomed fetch.
 */
export function isLocalApiUnavailable(baseUrl: string | undefined | null): boolean {
  if (typeof window === 'undefined' || !baseUrl) return false;
  const host = window.location.hostname;
  const pageIsLocal = host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0';
  const apiIsLocal = /(?:^|\/\/)(?:localhost|127\.0\.0\.1|0\.0\.0\.0)(?::\d+)?/.test(baseUrl);
  return apiIsLocal && !pageIsLocal;
}
